module.exports = __webpack_public_path__ + "static/Brex-hero-2651c3d8c0c325e1c8a571b188e9039a.jpeg";